import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let titleSceneC: any = null;
export default function EnergyBackup() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.EnergyBackup');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                titleSceneC = AniContainer.create({
                    triggerElement: '.EnergyBackup-detail .sticky-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
            };
        }
    }, []);

    return (
        <>
            <section className={`EnergyBackup-detail EnergyBackup-detail-section ${css['EnergyBackup-detail']}`} id="EnergyBackup-detail">
                <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                    <div className="img-box">
                        <EFPicture
                            src={'https://websiteoss.ecoflow.com/upload/image/1773197553190/3-pc-1.jpg'}
                            srcPad={'https://websiteoss.ecoflow.com/upload/image/1773197553035/3-m-1.jpg'}
                            srcMobile={'https://websiteoss.ecoflow.com/upload/image/1773197553035/3-m-1.jpg'}
                            alt={t('secEnergyBackup_title')}
                        />
                        <div className="mask"></div>
                        <div className="title-box">
                            <h2 className="title">{t('secEnergyBackup_title')}</h2>
                            <p className="desc">{t('secEnergyBackup_desc')}</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
